// extracted by mini-css-extract-plugin
export default {"base":"BottomSheetBody_base__S3BfS"};